import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ApiAdmin } from "../../Values";
import Cookies from "js-cookie";
import LoginCheck from "../../LoginCheckAdmin/page";
import Header_ from "../compoenents/Header_";
import { Modal, Spinner } from "react-bootstrap";

export default function Database() {
  const navigate = useNavigate();
  const [errors, Seterrors] = useState("");
  const [ShowModal, SetShowModal] = useState(false);
  const [restoreFile, setRestoreFile] = useState(null);
  const [isLoading, setIsLoading] = useState(false); // ✅ حالة التحميل

  LoginCheck();

  async function handeldatabaseBackup() {
    if (window.confirm("هل تريد عمل نسخة احتياطية؟")) {
      try {
        setIsLoading(true); // ⏳ بدء التحميل
        const post = { Action: "databaseBackup" };
        const response = await fetch(ApiAdmin + "/Database.php", {
          method: "POST",
          body: JSON.stringify(post),
        });

        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;

        let fileName = "backup.sql";
        const contentDisposition = response.headers.get("Content-Disposition");
        if (contentDisposition) {
          const utf8Match = contentDisposition.match(/filename\*\=UTF-8''"?([^\";]+)"?/);
          const fallbackMatch = contentDisposition.match(/filename="?([^\";]+)"?/);
          if (utf8Match) {
            fileName = decodeURIComponent(utf8Match[1]);
          } else if (fallbackMatch) {
            fileName = fallbackMatch[1];
          }
        }

        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      } catch (error) {
        Seterrors("فشل النسخ الاحتياطي");
        SetShowModal(true);
      } finally {
        setIsLoading(false); // ⛔ انتهاء التحميل
      }
    }
  }

  async function handeldatabaseDelete() {
    if (window.confirm("هل تريد حذف قاعدة البيانات؟")) {
      try {
        setIsLoading(true);
        const post = { Action: "databaseDelete" };
        const response = await fetch(ApiAdmin + "/Database.php", {
          method: "POST",
          body: JSON.stringify(post),
        });
        const data = await response.json();
        alert(data.msg);
      } catch (error) {
        Seterrors("فشل حذف قاعدة البيانات");
        SetShowModal(true);
      } finally {
        setIsLoading(false);
      }
    }
  }

  async function handeldatabaseRestore() {
    if (!restoreFile) {
      alert("يرجى اختيار ملف SQL");
      return;
    }

    if (window.confirm("هل تريد استرجاع قاعدة البيانات؟")) {
      try {
        setIsLoading(true);
        const formData = new FormData();
        formData.append("Action", "databaseRestore");
        formData.append("file", restoreFile);

        const response = await fetch(ApiAdmin + "/databaseRestore.php", {
          method: "POST",
          body: formData,
        });

        const contentType = response.headers.get("content-type");
        if (response.ok && contentType && contentType.includes("application/json")) {
          const data = await response.json();
          alert(data.msg);
        } else {
          const text = await response.text();
          Seterrors("⚠️ " + (text || "استجابة غير مفهومة من السيرفر"));
          SetShowModal(true);
        }
      } catch (error) {
        Seterrors("❌ فشل الاتصال بالسيرفر");
        SetShowModal(true);
      } finally {
        setIsLoading(false);
      }
    }
  }

  return (
    <>
      <Header_ />
      <div dir="rtl" className="row p-0 mt-0 text-end m-auto" style={{ maxWidth: "600px" }}>
        <h3 className="text-orange fw-bold py-1 mt-2">
          <Link to="../admin/Setting">
            <i className="fa-solid fa-chevron-right text-orange bg-light p-1 mx-2 fs-4"></i>
          </Link>
          {"Database Setting"}
        </h3>

        <div className="col-12">
          <div className="card bg-light shadow">
            <div className="card-body text-center">
              <label className="col-form-label">Backup Database</label><br />
              <button className="btn btn-orange my-4 w-50" onClick={handeldatabaseBackup} disabled={isLoading}>
                {isLoading ? <Spinner size="sm" animation="border" /> : "Backup Database"}
              </button>
            </div>
          </div>

          <div className="card bg-light shadow mt-4">
            <div className="card-body text-center">
              <label className="col-form-label">Restore Database</label>
              <input
                type="file"
                className="form-control my-2"
                accept=".sql"
                disabled={isLoading}
                onChange={(e) => setRestoreFile(e.target.files[0])}
              />

              <button className="btn btn-green w-50" onClick={handeldatabaseRestore} disabled={isLoading}>
                {isLoading ? <Spinner size="sm" animation="border" /> : "Restore Database"}
              </button>
            </div>
          </div>

          <div className="card bg-light shadow mt-4">
            <div className="card-body text-center">
              <label className="col-form-label">Delete Database</label><br />
              <button className="btn btn-danger my-4 w-50" onClick={handeldatabaseDelete} disabled={isLoading}>
                {isLoading ? <Spinner size="sm" animation="border" /> : "Delete Database"}
              </button>
            </div>
          </div>
        </div>
      </div>

      <Modal show={ShowModal} onHide={() => SetShowModal(false)}>
        <Modal.Body>
          <div className="row">
            <div className="col-12 text-center">
              <h4 className="text-start">خطأ</h4>
              <hr />
              <h5 className="text-center">{errors}</h5>
              <button className="btn btn-danger w-50 m-3" onClick={() => SetShowModal(false)}>OK</button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}
